import React from 'react';
import { LinkInterface } from '@/types';
import { CurveLine, Link } from '@/components';

interface HeadingProps {
  title?: string;
  isShowButton?: boolean;
  cta?: LinkInterface | undefined;
  className?: string;
  isShowCurveLine?: boolean;
  isWhite?: boolean;
  titleClassName?: string;
}

const Heading: React.FC<HeadingProps> = ({
  title,
  isShowButton = false,
  cta,
  className = '',
  isShowCurveLine = true,
  isWhite = false,
  titleClassName = '',
}) => {
  return (
    <div className={className ? className : 'mb-5'}>
      <div className='mb-2.5 flex items-center justify-between'>
        {title && (
          <h2
            className={`font-halyarddisplay text-2xl font-semibold sm:text-4xl ${isWhite ? `text-white` : ''} ${titleClassName}`}
          >
            {title}
          </h2>
        )}
        {isShowButton && cta && (
          <Link
            {...cta}
            variant='default'
            size='sm'
          >
            {cta?.label}
          </Link>
        )}
      </div>
      {isShowCurveLine && (
        <CurveLine
          className='flex items-center'
          isWhite={isWhite}
        />
      )}
    </div>
  );
};

export default Heading;
